import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Component, OnInit, ElementRef, Input, Output, EventEmitter, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';
import { IWizardStep } from '@clooper/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { filter } from 'rxjs/operators';
import { faEllipsisHAlt } from '@fortawesome/pro-light-svg-icons/faEllipsisHAlt';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faHomeAlt } from '@fortawesome/pro-light-svg-icons/faHomeAlt';
import { faPeopleArrows } from '@fortawesome/pro-light-svg-icons/faPeopleArrows';
import { faHouseUser } from '@fortawesome/pro-light-svg-icons/faHouseUser';
import { faHouseReturn } from '@fortawesome/pro-light-svg-icons/faHouseReturn';
import { faTools } from '@fortawesome/pro-light-svg-icons/faTools';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faAddressBook } from '@fortawesome/pro-light-svg-icons/faAddressBook';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faUserEdit } from '@fortawesome/pro-light-svg-icons/faUserEdit';
import { faBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faShareAll } from '@fortawesome/pro-light-svg-icons/faShareAll';
import { faUserHeadset } from '@fortawesome/pro-light-svg-icons/faUserHeadset';
import { faThLarge } from '@fortawesome/pro-light-svg-icons/faThLarge';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';

export const _userRoles = {
  LANDLORD: 'landlord',
  TENANT: 'tenant',
  TRADEPERSON: 'tradeperson',
  HOMEOWNER: 'homeowner'
}

export interface ILink {
  icon: IconProp
  name: string
  url: string
  match?: { exact: boolean }
}

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit, OnChanges {
  icons: any = {
    hdots: faEllipsisHAlt,
    back: faArrowLeft,
    check: faCheck,
    dashboard: faHomeAlt,
    trade: faPeopleArrows,
    property: faHouseUser,
    tenacy: faHouseReturn,
    job: faTools,
    payment: faCreditCard,
    contact: faAddressBook,
    lead: faUsers,
    compliance: faShieldCheck,
    home: faHomeAlt,
    profile: faUserEdit,
    cards: faCreditCard,
    notification: faBell,
    shareEarn: faShareAll,
    userHeadSet: faUserHeadset,
    thLarge: faThLarge
  }
  @Input() viewType = 'user';
  @Input() toggled: boolean;
  @Input() wizardSteps: IWizardStep[] = [];
  @Input() active: string;
  @Input() userRole: string;
  @Output() collapsed = new EventEmitter<boolean>();
  @Input() menuItems: any[];
  @Input() menuType: string;


  // Constants
  navTypes = {
    MENU: 'menu',
    WIZARD: 'wizard',
    MOCKUP: 'mockup',
    CONFIG: 'config'
  }



  isCollapsed: boolean;
  isCollapseDone: boolean;
  selectedType: string;

  // userRoles = _userRoles;

  /* FULL APP MENU
  menuItems: ILink = [
    {
      icon: this.icons.dashboard,
      name: 'Dashboard',
      url: '/'
    },
    {
      icon: this.icons.property,
      name: 'Properties',
      url: '/properties'
    },
    {
      icon: this.icons.tenacy,
      name: 'Tenancies',
      url: '/tenancies'
    },
    {
      icon: this.icons.trade,
      name: 'Jobs',
      url: '/jobs'
    },
    {
      icon: this.icons.lead,
      name: 'Leads',
      url: '/leads'
    },
    {
      icon: this.icons.compliance,
      name: 'Compliance',
      url: '/compliance'
    },
    {
      icon: this.icons.payment,
      name: 'Payments',
      url: '/payments'
    },
    {
      icon: this.icons.contact,
      name: 'Contacts',
      url: '/contacts'
    }
  ]
  */


  /* SETTINGS MENU */


  private nav: HTMLElement;
  currentYear: number;

  constructor(
    private el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private router: Router) {
    this.nav = this.el.nativeElement as HTMLElement;
  }

  ngOnInit() {
    this.cdRef.detectChanges()
    this.wizardSteps = this.menuItems
    this.setType();
    // this.getActiveStep()

    this.currentYear = new Date().getFullYear()
  }
  ngOnChanges(changes: SimpleChanges) {
    const menuType = changes.menuType ? changes.menuType.currentValue : this.menuType;
    const menuItems = changes.menuItems ? changes.menuItems.currentValue : this.menuItems;
    const active = changes.active ? changes.active.currentValue : this.active;
    this.menuType = menuType;
    this.menuItems = menuItems;
    this.wizardSteps = menuItems
    // this.active = active;
    this.setType();
    // this.getActiveStep()
  }

  private setType(): void {
    if (this.nav.hasAttribute('menu') || this.menuType === 'menu') {
      this.selectedType = this.navTypes.MENU;
    }
    else if (this.nav.hasAttribute('wizard') || this.menuType === 'wizard') {
      this.selectedType = this.navTypes.WIZARD;
    }
    else if (this.nav.hasAttribute('mockup') || this.menuType === 'mockup') {
      this.selectedType = this.navTypes.MOCKUP;
    }
    else if (this.nav.hasAttribute('config') || this.menuType === 'config') {
      this.selectedType = this.navTypes.CONFIG;
    }
  }
  getActiveStep() {
    this.getWizardActiveStep()
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.getWizardActiveStep()
      })
  }
  collapse() {
    this.isCollapsed = !this.isCollapsed;
    setTimeout(() => {
      this.isCollapseDone = this.isCollapsed;
    }, 1000);
    this.collapsed.emit(this.isCollapsed);
  }
  getWizardActiveStep() {
    if (!this.wizardSteps) return;
    let urlPath = location.pathname;
    let url = urlPath.split('/')
    urlPath = url.slice(0, url.length - 1).join('/')
    const activeStep = this.wizardSteps.find(step => step.url.startsWith(urlPath))
    this.active = activeStep ? activeStep.name : '';
  }

  goBack() {
    this.router.navigateByUrl('/');
  }
}
